(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["panel-glass-reviews"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('panel-glass-reviews')) {
  customElements.define('panel-glass-reviews', class extends HTMLElement {
    connectedCallback() {
      this.track=this.querySelector('.pgr__track');
      this.cards=[...this.querySelectorAll('.pgr__card')];
      this.dots=[...this.querySelectorAll('.pgr__dot')];
      this.controls=this.querySelector('.pgr__controls');
      this.abort=new AbortController();
      const options={signal:this.abort.signal};
      this.update=()=>{
        if(!this.track||!this.cards.length)return;
        const max=this.track.scrollWidth-this.track.clientWidth;
        const left=this.track.scrollLeft;
        if(this.controls)this.controls.hidden=max<4;
        const origin=this.track.getBoundingClientRect().left;
        let nearest=0;
        this.cards.forEach((card,i)=>{if(Math.abs(card.getBoundingClientRect().left-origin)<Math.abs(this.cards[nearest].getBoundingClientRect().left-origin))nearest=i;});
        if(left>=max-4&&max>4)nearest=this.cards.length-1;
        this.dots.forEach((dot,i)=>{if(i===nearest)dot.setAttribute('aria-current','true');else dot.removeAttribute('aria-current');});
        const prev=this.querySelector('[data-direction="-1"]'),next=this.querySelector('[data-direction="1"]');
        if(prev)prev.disabled=left<4;
        if(next)next.disabled=left>=max-4;
      };
      this.go=(index)=>{
        const card=this.cards[index];if(!card)return;
        const left=card.getBoundingClientRect().left-this.track.getBoundingClientRect().left+this.track.scrollLeft;
        this.track.scrollTo({left,behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth'});
      };
      this.addEventListener('click',event=>{
        const dot=event.target.closest('[data-review-index]');if(dot)this.go(Number(dot.dataset.reviewIndex));
        const arrow=event.target.closest('[data-direction]');
        if(arrow)this.track.scrollBy({left:Number(arrow.dataset.direction)*(this.cards[0].getBoundingClientRect().width+parseFloat(getComputedStyle(this.track).gap)),behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth'});
      },options);
      this.track.addEventListener('scroll',this.update,{...options,passive:true});
      this.addEventListener('shopify:block:select',event=>{
        const index=this.cards.findIndex(card=>card.dataset.reviewId===event.detail.blockId);if(index>=0)this.go(index);
      },options);
      this.observer=new ResizeObserver(this.update);this.observer.observe(this.track);this.update();
    }
    disconnectedCallback(){this.abort?.abort();this.observer?.disconnect();}
  });
}

  } catch(e) { console.error(e); }
})();
})();
